import { type FC } from 'react';
import { isNotEmpty, useForm } from '@mantine/form';
import { Button, Group, Select, Stack, Textarea } from '@mantine/core';
import { useAppealPayinOrder } from '~/entities/payin';
import { PayinCommonAppealV1TraderReason } from '~/generated/payinBackend/model';
import { appealReasons } from './constants';

export interface AppealProps {
    id: string;
    onCancel?: VoidFunction;
    onSuccess?: VoidFunction;
    onError?: (error: Error) => void;
}

export const Appeal: FC<AppealProps> = ({ id, onCancel, onSuccess, onError }) => {
    const { mutate, isPending } = useAppealPayinOrder({ onSuccess, onError });

    const form = useForm({
        initialValues: {
            orderId: {
                value: id,
            },
            reason: PayinCommonAppealV1TraderReason.TRADER_REASON_MERCHANT_FRAUD,
            comment: '',
        },
        validate: {
            comment: isNotEmpty('Комментарий обязателен к заполнению'),
        },
    });

    return (
        <form
            onSubmit={form.onSubmit((values) => {
                mutate(values);
            })}
        >
            <Stack miw={300}>
                <Select
                    label='Причина апелляции'
                    data={appealReasons}
                    {...form.getInputProps('reason')}
                />

                <Textarea
                    label='Комментарий'
                    {...form.getInputProps('comment')}
                />

                <Group justify='flex-end'>
                    <Button
                        title='Открыть спор'
                        color='red'
                        disabled={isPending}
                        loading={isPending}
                        type='submit'
                    >
                        Открыть спор
                    </Button>

                    {onCancel && (
                        <Button
                            title='Отмена'
                            disabled={isPending}
                            onClick={onCancel}
                        >
                            Отмена
                        </Button>
                    )}
                </Group>
            </Stack>
        </form>
    );
};
